import { UserResource } from "@/types/resources";
import { api, baseApi } from "@/utils/api";
import { createModel } from "@rematch/core";
import { batch } from "react-redux";
import { RootModel } from ".";

interface State {
  user: UserResource | null;
}

const initialState: State = {
  user: null,
};

export const auth = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setUser(state, user: UserResource | null) {
      return { ...state, user };
    },

    updateUserProperties(state: State, properties: Partial<UserResource>) {
      return {
        ...state,
        user: {
          ...state.user!,
          ...properties,
        },
      };
    },
  },
  effects: (dispatch) => ({
    async fetchCurrentUser() {
      const { user } = await api.get<never, { user: UserResource | null }>(
        "/v1/user"
      );
      batch(() => {
        dispatch.teams.setTeams(user?.teams || []);
        dispatch.auth.setUser(user);
      });

      return user;
    },

    async logout() {
      await baseApi.get(`/sanctum/csrf-cookie`);
      await baseApi.post(`/logout`);
      window.location.reload();
    },
  }),
});
